import styles from "./GoogleReviewBox.module.css";
import { IReviews, IReviewsArr } from "@/interfaces/IReviews";
import { ILandingPageData } from "@/interfaces/ILandingPage";
type props = {
    reviewsdata: IReviews
    data: ILandingPageData['googleReviewBox']
}
export function GoogleReviewBox({ reviewsdata, data: { headingText, subHeadingText, leadBtnText } }: props) {
    if (!reviewsdata || Object.keys(reviewsdata).length == 0) return null;
    return (
        <section className="section bgGray">
            <div className="container1350">
                <div className="container1350">
                    <h2 className="font26 text222 fontSM20 textUpper f500 mb20 reviweHeading mbSM10">
                        {headingText}
                    </h2>
                    <p className="font20 text666 mb46 reviwePara fontSM14 lineheightSM3 mbSM15">{subHeadingText}</p>
                    <div className={styles.googleReviweBox}>
                        <div className={styles.leftRewviwBox}>
                            <img className="img-responsive mb20 mbSM8" src="/assets/images/google-review-new-img.svg" alt="" />
                            <span className="text222 font70 mb20 mbSM8">
                                4.4
                            </span>
                            <div className="starBox mb16 mbSM5">
                                <div className={styles.rating}>
                                    <div className={styles.ratingColor} style={{ width: `${(reviewsdata.rating) * 20}%` }}></div>
                                </div>
                            </div>
                            <p className="text666 font16 reviewBased fontSM12 mt12">
                                Based on {reviewsdata.user_ratings_total} Reviews
                            </p>
                        </div>
                        <div className={`${styles.rightReviewBox} scrollBarHide`}>
                            <div className={styles.rightrateviewBox}>
                                <div className={`${styles.usergoogleRewBox} scrollBarHide`}>
                                    {reviewsdata.reviews.filter((f) => f.rating >= 3).sort((a, b) => (b.rating - a.rating)).map((reviews: IReviewsArr, index: number) =>
                                        <div className={styles.userFulldeatlis} key={index}>
                                            <p className="font16 text000 fbold mb12 userReviwname fontSM12 mbSM5">{reviews.author_name}</p>
                                            <div className={`${styles.ratingpoinBox} mb12 mbSM5`}>
                                                <p className="font14 text000 fbold fontSM12">{reviews.rating}</p>
                                                <div className={styles.rating}>
                                                    <div className={styles.ratingColor} style={{ width: `${reviews.rating * 20}%` }}></div>
                                                </div>
                                            </div>
                                            <p className="text222 font14 lineHeight20 userCommnet fontSM12 lineheightSM3">{reviews.text.slice(0, 200)}...</p>
                                        </div>
                                    )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.googleRewvbtbox}>
                        <button className="btnPrimery" id="openExitIntentForm">{leadBtnText}</button>
                    </div>
                </div>
            </div>
        </section>
    )
}